import { ServicePaymentMergedSchema } from '@/modules/pay/pages/services/ServicePaymentWithoutApplication/model/schemas';

import { PaymentInfoRequest, PaymentInvoiceRequest } from '@/api/types';

interface Props {
  formData: ServicePaymentMergedSchema;
}

export const generatePayload = ({ formData }: Props): PaymentInfoRequest => {
  const service = formData.defraymentService;
  const subService = formData.defraymentSubService;

  const defraymentService = subService || service;

  if (!defraymentService) throw new Error('missed required data');

  return {
    org_npu_id: formData?.orgNpu?.id ?? '',
    drfo_code: formData?.rnokpp ?? '',
    defrayment_service_id: defraymentService.id!,
  };
};

export const generatePayloadForCreationOfInvoice = ({ formData }: Props): PaymentInvoiceRequest => {
  const service = formData.defraymentService;
  const subService = formData.defraymentSubService;

  const defraymentService = subService || service;

  return {
    full_name: formData.fullName as string,
    drfo_code: formData.rnokpp as string,
    org_npu_id: formData?.orgNpu?.id ?? '',
    defrayment_service_id: defraymentService?.id ?? '',
  } satisfies PaymentInvoiceRequest;
};
